/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2015, 2017. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
/*eslint-env browser, amd, node*/
"use strict";

var Log = {
  getLogger: function getLogger(name) {
    return new Logger(name);
  }
};
function Logger(name) {
  this.name = name;
}
["debug", "info", "log", "warn", "error"].forEach(function (methodName) {
  var method = console[methodName] || console.log;
  //Logger.prototype[methodName] = method.bind(console);
  Logger.prototype[methodName] = makeWrapper(console, method);
});
function makeWrapper(console, method) {
  return function () {
    if (!this.name) {
      return method.apply(console, arguments);
    }
    var prefix = "[" + this.name + "]";
    return method.apply(console, [prefix].concat(Array.prototype.slice.call(arguments)));
  };
}
module.exports = Log;